import tools from './tools.js'
export default {
  getTitle /** 返回对应头部标题 */,
  getDictionaryText /** 根据传入value值 返回对应的字典文字*/,
  verifTel /** 电话号码验证*/,
  verifDouble /** 验证租售价格*/,
  getQuery,
  dataFormat /** 发送数据到后端前 格式化数据*/,
  goPosition /** 当前点击位置 滚动到当前视窗中心*/,
  numFormat,
  getPrice /** 租售价转文字 */,
  getAreaToText /** 建筑面积实用面积转成正确格式 */,
  getAvgPriceToText /** 建筑面积实用面积均价转成正确格式 */
};

/** 租售价转文字 并保留两位小数 */
/** type {1: "放售", 2: "放租"} */
function getPrice(price, language) {
  return tools.getPrice(price,language);
}
/**
 * 建筑面积实用面积均价转成正确格式
 * build:buildingArea 建筑面积
 * sale:saleableArea 实用面积
 *language:当前语言 isVerifyArea:是否均
 * Sq.ft 平方尺
 **/
function getAreaToText(build, sale, language, isVerifyArea) {
  let approx = '';
  /** 判断面积是否确定 */
  if (!isVerifyArea) {
    approx = language === 'zh-hk' ? '約' : language === 'zh-cn' ? '约' : '~';
  }
  const leftBulid = language === 'zh-hk' ? '建' : language === 'zh-cn' ? '建' : 'GFA';
  const leftSale = language === 'zh-hk' ? '實' : language === 'zh-cn' ? '实' : 'SA';
  const right = language === 'zh-hk' ? '呎' : language === 'zh-cn' ? '尺' : 'sq.ft';
  if (!build && !sale) {return '';}
  else if (build && sale) {return approx + build + '/' + approx + sale + right;}
  else if (!build) {return leftSale + (approx ? `${approx}` : '') + sale + right;}
  else if (!sale) {return leftBulid + (approx ? `${approx}` : '') + build + right;}
}
/**
 * 建筑面积实用面积均价转成正确格式
 * sale:saleableAvgPaidPrice 实用均价
 * build:buildingAvgPaidPrice 建筑均价
 */
function getAvgPriceToText(build, sale, language) {
  const text = language === 'en-us' ? '@$' : '@$';
  if (!build && !sale) {return '';}
  else if (build && sale) {return text + Math.round(build) + '/' + text + Math.round(sale);}
  else if (!build) {return text + Math.round(sale);}
  else if (!sale) {return text + Math.round(build);}
}

function numFormat(type, price, en, lang) {
  if (type == 'sale') {
    if (String(price).length >= 9 && !en) {
      price = price / 100000000;
      return Math.round(price * 100) / 100 + lang.yi;
    } else if (en) {
      price = price / 1000000;
      return Math.round(price * 100) / 100 + lang.wan;
    }
      price = price / 10000;
      return Math.round(price * 100) / 100 + lang.wan;

  }
    if (String(price).length >= 9 && !en) {
      price = price / 100000000;
      return Math.round(price * 100) / 100 + lang.yi;
    } else if (String(price).length >= 9 && en) {
      price = price / 1000000;
      return Math.round(price * 100) / 100 + lang.wan;
    } else if (price >= 100000 && price < 100000000 && !en) {
      price = price / 10000;
      return Math.round(price * 100) / 100 + lang.wan;
    } else if (en) {
      price = price / 1000;
      return Math.round(price * 100) / 100 + 'k';
    }
      return price;


}
function dataFormat(vm) {
  const typeList = {
    buildingAge: 'int',
    buildingArea: 'int',
    saleableArea: 'int',
    salePrice: 'int',
    rentPrice: 'int',
    unitFloor: 'int',
    roomNumber: 'int',
    propertyManagementFee: 'int',
    saleForm: 'int',
    rentLabel: 'Array',
    subCategory: 'Array'
  };
  // 如果是业主盘 就删除代理人信息
  if (vm.postInfo.propertySource == 1) {
    delete vm.propertyUserInfo.companyNameCN;
    delete vm.propertyUserInfo.companyNameEN;
    delete vm.propertyUserInfo.companyTel;
    delete vm.propertyUserInfo.customerTel;
    delete vm.propertyUserInfo.companyAddress;
    delete vm.propertyUserInfo.companyLicenceNumber;
    delete vm.propertyUserInfo.agentLicenceNumber;
    delete vm.propertyUserInfo.agentCardPath;
  }
  // 如果类型是 车位 删除 多余信息
  if (vm.postInfo.propertyCategory == 4) {
    delete vm.postInfo.buildingArea;
    delete vm.postInfo.saleableArea;
    if (vm.postInfo.rentalType == 1 || vm.postInfo.rentalType == 'sale') {
      delete vm.postInfo.saleForm;
      delete vm.postInfo.isLinkParking;
      // delete vm.propertyInfo.isVerifyArea
    } else {
      delete vm.postInfo.rentLabel;
      // delete vm.propertyInfo.isVerifyArea
    }
  }
  // 如果是售 就删除租信息
  if (vm.postInfo.rentalType == 1 || vm.postInfo.rentalType == 'sale') {
    delete vm.postInfo.rentPrice;
    delete vm.postInfo.beginRentTime;
    delete vm.postInfo.rentLabel;
  }
  // 如果是租 就删除信息
  if (vm.postInfo.rentalType == 2 || vm.postInfo.rentalType == 'rent') {
    if (vm.postInfo.beginRentTime == 0) {
      delete vm.postInfo.beginRentTime;
    }
    delete vm.postInfo.salePrice;
    delete vm.postInfo.saleForm;
    delete vm.postInfo.isLinkParking;
  }

  // 遍历格式化楼盘信息
  for (let key in vm.postInfo) {
    if (key === 'similar') {
      vm.postInfo.PropertySimilar = vm.postInfo[key];
    }
    if (key === 'beginRentTime') {
      vm.postInfo[key] = parseInt(vm.postInfo[key] / 1000);
    }
    if (key === 'salePrice') {
      vm.postInfo[key] = parseInt(vm.postInfo[key] * 10000);
    }
    if (typeList[key] === 'Array' && vm.postInfo[key]) {
      vm.postInfo[key] = vm.postInfo[key].map(Number);
    }
    if (typeList[key] === 'int') {
      vm.postInfo[key] = Number(vm.postInfo[key]);
    }
    if (vm.postInfo[key] === '' || vm.postInfo[key] === null || vm.postInfo[key] === undefined || Number.isNaN(vm.postInfo[key])) {
      delete vm.postInfo[key];
    }
  }
}
function goPosition(e, vm) {
  // ios 自带滚动效果 不需要
  if (vm == 'ios') {
    return;
  }
    e.target.scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    });

}
function getQuery(vm) {
  if (document.URL.indexOf('?') > -1) {
    vm.query = '?' + document.URL.split('?')[1];
  } else {
    vm.query = '';
  }
}
function verifTel(num) {
  return !/^[2-9]{1}\d{7}$/.test(num);
}
function verifDouble(num) {
  // return !/^\d{0,12}\.{0,1}\d{0,2}$/.test(num);
  return !/^\d{0,12}$/.test(num);
}
//根据字典value获取到 字典文字 （value,字典,给谁赋值）
function getDictionaryText(value, Dictionary) {
  return Dictionary.find(item => {
    if (item.dictionaryValue == value) {
      return item;
    }
  }).dictionaryNameWithCulture;
}

function getTitle(vm, lang) {
  if (JSON.stringify(vm.$route.query) && vm.$route.query.hasOwnProperty('type') == false) {
    vm.mode = 'post';
    return lang.toptitle;
  }
  if (vm.$route.query.type == 'edit') {
    vm.mode = 'edit';
    return lang.edittitle + '(' + vm.$route.query.id + ')';
  }
  if (vm.$route.query.type == 'copy') {
    vm.mode = 'copy';
    return lang.copytitle;
  }
  if (vm.$route.path.indexOf('pay') > -1 && vm.$route.query.type == 1) {
    vm.mode = 'paynow';
    return lang.paytitle + '(id:' + vm.orderID + ')';
  }
  if (vm.$route.path.indexOf('pay') && vm.$route.query.type == 2) {
    vm.mode = 'renewal';
    return lang.addSuntitle;
  }
}
